export default __webpack_public_path__ + "static/media/ic_filter.2b4cd100.svg";